var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kendo-datepicker',{staticStyle:{"width":"120px"},attrs:{"value":_vm.selectedDate,"format":'yyyy-MM-dd'},on:{"change":_vm.selectedDateChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }